import { Modal as ModalDrawer } from '@nt/dds-react';
import React from 'react';

import './Modal.css';
import { DrawerFooter, DrawerHeader } from '../../../utils/types';

interface Props {
  header?: DrawerHeader;
  footer?: DrawerFooter;
  customFooter?: React.ReactNode;
  children?: React.ReactNode;
  isOpen: boolean;
  size?: string;
  alert?: boolean;
}

const Modal: React.FC<Props> = ({ children, header, footer, customFooter, isOpen, size, alert }) => {
  const hasDefaultFooterActions = Boolean(
    !customFooter && (footer?.primaryAction || footer?.secondaryAction || footer?.tertiaryAction)
  );

  return (
    <ModalDrawer
      alert={alert}
      closeTimeoutMS={0}
      containerFooterProps={
        hasDefaultFooterActions
          ? {
            buttonArrangement: footer?.buttonArrangement,
            defaultButtonFocus: undefined,
            primaryAction: footer?.primaryAction,
            secondaryAction: footer?.secondaryAction,
            tertiaryAction: footer?.tertiaryAction
          }
          : undefined
      }
      containerHeaderProps={header}
      fullscreenOnMobile
      id="Modal_Id1"
      isOpen={isOpen}
      nextVersion
      onAfterOpen={function noRefCheck () {}}
      rootAppElement="#app"
      shouldCloseOnOverlayClick
      showCloseButton
      size={size ?? 'medium'}
      className="modal-wrap"
    >
      {children}
      {customFooter && <div className="modal-custom-footer">{customFooter}</div>}
    </ModalDrawer>
  );
};

Modal.displayName = 'Modal';
export default Modal;
